import { useEffect } from "react";
import { useState } from "react";
import { useFetch } from "../../../common/hooks/useFetch";
import { listComplianceByQuarterService } from "../services/listComplianceByQuarter.service";
import debounce from "lodash.debounce";

export const useComplianceByQuarter = (filters) => {
  const fetchData = useFetch();
  const [compliance, setCompliance] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    const fetchTasks = async () => {
      try {
        setLoading(true);
        const response = await listComplianceByQuarterService(fetchData)({
          ...filters,
        });
        setCompliance(response.data);
      } catch (error) {
        console.error("Error:", error);
      } finally {
        setLoading(false);
      }
    };

    const debounced = debounce(fetchTasks, 600);
    debounced();
    return () => debounced.cancel();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    filters?.status,
    filters?.type,
    filters?.startDate,
    filters?.endDate,
    filters?.year,
    filters?.quarter,
    refresh,
  ]);

  return {
    compliance,
    loading,
    refresh: () => setRefresh((prev) => !prev),
  };
};
